<template>
  <div id="batch-tab">
    <Loader v-if="loading" /> 
    <div v-else class="main-container container">
      <div style="padding-top: 32px; padding-bottom: 32px">
        <h4>Animais:</h4>
        <div class="detalhar-lote" style="padding:0px">
          <RegisterButtons :batchDetail="batchDetail" :batch="batch"/>
          <button 
            v-if="batch && !loading && isAdmin" 
            class="edit-losses-btn" 
            data-toggle="modal" 
            data-target="#editBaixaModal"
          >
            <i class="fas fa-edit"></i> VER BAIXAS
          </button>
        </div>
      </div>

      <div class="divider" v-if="modalDeparture == null"></div>
      <div v-if="firstBatch && barn !== null">
        <div v-if="batch == null || batchDetail.date_departure !== null && isAdmin" style="display: flex; justify-content: center; align-items: center;" class="batch-container register-batch-not-admin">
          <div>
            <button data-toggle="modal" data-target="#batchModal">
              <h1>Nenhum lote</h1>
              <p>clique para cadastrar</p>
            </button>
          </div>
        </div>
      </div>
      <Loader v-if="barn == null" /> 

      <div class="batch-container" v-if="!firstBatch || batch !== null && batch.date_departure == null">
        <h4>Lote {{batch.pk}}:</h4>
        <div v-if="batch != null" class="batch-info-container">
          <div class="batch-cards-container">
            <div class="batch-card-row">              
              <div>
                <p>Peso Inicial</p>
                <span>{{batchDetail.average_initial_weight}} kg</span>
              </div>

              <div>
                <p>Peso Final</p>
                <span>{{final(batchDetail.average_final_weight)}}</span>
              </div>

              <div>
                <p>Peso Desejado</p>
                <span>{{batchDetail.desired_weight}} kg</span>
              </div>
              
              <div>
                <p>Qtd Inicial</p>
                <span>{{batchDetail.initial_count}}</span>
              </div>

              <div>
                <p>Qtd Final</p>
                <span>{{final(batchDetail.final_count)}}</span>
              </div>

              <div>
                <p>Perdas</p>
                <span>{{batchDetail.loss}}</span>
              </div>

              <div v-if="batchBirthDate">
                <p>Data de Nascimento</p>
                <span>{{ formatBatchDate(batchBirthDate) }}</span>
              </div>

              <div v-if="batchAgeDisplay">
                <p>Idade do Lote</p>
                <span>{{ batchAgeDisplay }}</span>
              </div>
            </div>
          </div>

          <div class="batch-date-modal">
            <div class="date-input">
              <div class="calendario">
                Data inicial: <br />
                <input disabled id="date_init" class="form-control" type="date" :value="batchDetail.date_accomodation"/>
              </div>

              <div class="calendario-final">
                Data final: <br />
                <div v-if="batchDetail.date_departure == null" class="message">Lote em aberto</div>
                <input v-else disabled id="date_finish" class="form-control" type="date" :value="batch.date_departure"/>
              </div>
            </div>

             <div v-if="isAdmin && batch.date_departure == null" class="batch-modal-buttons-container">
              <div class="batch-modal-button-edit-batch" data-toggle="modal" data-target="#EditBatchModal">
                <a id="atualizar" class="btn btn-primary text-white">EDITAR LOTE</a>
              </div>
              
              <div class="batch-modal-button-end-batch" data-toggle="modal" data-target="#EndBatchModal">
                <a id="atualizar" class="btn btn-primary text-white">{{modalMessage}}</a>
              </div>
            </div> 
            <div class="button-cadastrar"  v-if="batch.date_departure !== null">
              <button data-toggle="modal" data-target="#batchModal">
                CADASTRAR LOTE
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ModalStyle>
      <RegisterBatchModal />
      <EndBatchModal />
      <EditBatchModal :batchDetail="batchDetail"/>
      <EditLossModal />
    </ModalStyle>
  </div>
</template>

<script>
import RegisterBatchModal from "../components/RegisterBatchModalOld.vue";
import EndBatchModal from "../components/EndBatchModal.vue";
import EditBatchModal from "../components/EditBatchModal.vue";
import ModalStyle from "../components/ModalStyle.vue";
import RegisterButtons from "./RegisterButtons.vue";
import Loader from "./Loader.vue";
import EditLossModal from "./EditLossModal.vue";

export default {
  name: "BatchTab",
  components: {
    ModalStyle,
    EndBatchModal,
    EditBatchModal,
    RegisterBatchModal,
    RegisterButtons,
    Loader,
    EditLossModal
  },
  data() {
    return{
      loading:true,
    }
  }, 
  methods: {
    final(value) {
      try {
        if (value == null) return "Em Andamento"
        return value
      }
      catch(err) {
        return "Em Andamento"
      }
    },
    formatBatchDate(dateValue) {
      if (!dateValue) return '-'
      const raw = String(dateValue).slice(0, 10)
      const [year, month, day] = raw.split('-')
      if (year && month && day) return `${day}/${month}/${year}`
      return raw
    },
    dateCompare(firstDate, secondDate) {
      return Math.ceil(
        Math.abs(new Date(secondDate) - new Date(firstDate)) / (1000 * 60 * 60 * 24)
      )
    },
    async getBatchDetail() {
      await this.$store.dispatch('fetchBatchDetail', this.batch.pk)
    }
  },
  computed: {
    modalAccommodation() {
      if (this.batch == null) return null
      return this.$store.getters.getBatchDetail.date_accomodation
    },
    modalDeparture() {
      if (this.batch == null) return null
      return this.$store.getters.getBatchDetail.date_departure
    },
    modalAverageInitialWeight() {
      if (this.batch == null) return null
      return this.$store.getters.getBatchDetail.average_initial_weight
    },
    modalDesiredWeight() {
      if (this.batch == null) return null
      return this.$store.getters.getBatchDetail.desired_weight
    },
    modalInitialCount() {
      if (this.batch == null) return null
      return this.$store.getters.getBatchDetail.initial_count
    },
    modalMessage() {
      try {
        if (this.batch.date_departure == null) return 'FINALIZAR LOTE'
        return 'EDITAR FINALIZAÇÃO'
      }
      catch(err) {
        return 'EDITAR FINALIZAÇÃO'
      }
    },
    workingSensors() {
      try {
        return this.barn.sensors.filter((sensor) => sensor.type === "smartfeed");
      } catch (err) {
        return [];
      }
    },
    barn() {
      return this.$store.getters.getBarnTarget;
    },
    batch() {
      return this.$store.getters.getBatchTarget;
    },
    firstBatch() {
      if (this.batch == null) {
        return true
      }
      return false
    },
    batchDetail() {
      return this.$store.getters.getBatchDetail[0]
    },
    isAdmin() {
      return this.$store.getters.getIsAdmin;
    },
    barnSensors() {
      return this.barn.sensors?.filter(item => item.type != 'smartmic_dummy_V3' && item.type != 'smartmic_central_V3')
    },
    batchBirthDate() {
      return this.batchDetail?.date_birth || null
    },
    batchReferenceEndDate() {
      const departure = this.batchDetail?.date_departure ?? this.batch?.date_departure
      return departure || new Date().toISOString().slice(0, 10)
    },
    batchAgeDays() {
      if (this.batchBirthDate) {
        return this.dateCompare(this.batchBirthDate, this.batchReferenceEndDate)
      }

      const storedDays = Number(this.batchDetail?.days_life)
      if (Number.isFinite(storedDays) && storedDays > 0) {
        return Math.round(storedDays)
      }

      const accommodation = this.batchDetail?.date_accomodation
      if (accommodation) {
        return this.dateCompare(accommodation, this.batchReferenceEndDate)
      }

      return null
    },
    batchAgeDisplay() {
      if (this.batchAgeDays == null || this.batchAgeDays <= 0) return null
      return `${this.batchAgeDays} dias`
    }
  },
  watch:{
    batch(newValue) {
      if (newValue !== null) {
        this.getBatchDetail()
        this.loading = false
      }
    }
  },
  async created() {
    if (this.batch !== null) {
      await this.$store.dispatch('fetchBatchDetail', this.batch.pk)
      this.loading = false
    }
    this.loading = false
  }
};
</script>

<style scoped>
.main-container {
  display: flex;
  flex-direction: column;
  padding: 32px 24px 0 24px;
}

.message {
  min-height: 38px;
  display: flex;
  align-items: center;
  background-color: #e9ecef;
  padding: 6px 12px;
  border: 1px solid #ced4da;
  border-radius: 4px;
}

.barn-container {
  width: 100%;
}

.batch-container {
  width: 100%;
  padding: 32px 0 0 0;
}

.old-batch-container {
  width: 100%;
}

.batch-information-cards {
  width: 50%;
}

.batch-date-modal {
  display: flex;
  flex-direction: row;
}

.divider{
  background: #c7c7c7;
  width: 100%;
  height: 1.75px;
}

.batch-info-container {
  display: flex;
  flex-direction: column;
}

.batch-info-container-ended-batch {
  display: flex;
  flex-direction: row;

  padding-top: 58px;
}

.sensor-list-container {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  padding: 12px 0;
}

.list-container {
  width: 100%;
  display: flex;
  font-size: 18px;
  padding: 12px 0;
  flex-direction: row;
}

.date-input {
  display: flex;
  flex-direction: row;
  width: 50%;
  padding-right: 5px;
}

.register-batch button {
  width: 280px;
  height: 100px;
  background: #fff;
  border: 4px solid #78b843;
  border-radius: 10px;
  outline: none;
  transition: 0.2s ease-out;
}

.register-batch button h1 {
  font-size: 32px;
  margin: 8px 0 -10px 0;
  color: #78b843;
}

.register-batch button:hover {
  background: #78b843;
}

.register-batch button:hover h1,
.register-batch button:hover p{
  color: #fff;
}

.register-batch button p {
  font-size: 24px;
  color: #78b843;
  padding: 10px;
  margin: 0;
}

.register-batch-not-admin button {
  width: 280px;
  height: 100px;
  background: #fff;
  border: 4px solid #78b843;
  border-radius: 10px;
  outline: none;
  transition: 0.2s ease-out;
  cursor: default;
}

.register-batch-not-admin button h1 {
  font-size: 32px;
  margin: 8px 0 -10px 0;
  color: #78b843;
}

.register-batch-not-admin button p {
  font-size: 24px;
  color: #78b843;
  padding: 10px;
  margin: 0;
}

.batch-modal-buttons-container {
  display: flex;
  flex-direction: row;
  width: 50%;
  padding: 10px 0 0 5px;
}

.batch-modal-button-end-batch {
  width: 50%;
  padding: 0 0 0 5px;
}

.batch-modal-button-edit-batch {
  width: 50%;
  padding: 0 5px 0 0;
}

.batch-cards-container {
  width: 100%;
}

.batch-card-row {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 8px;
  flex-wrap: wrap;
}

.batch-card-row div {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 8px;
  border-radius: 8px;
  margin: 2px;
  height: 90px;
  width: 12%;
  min-width: 120px;
  
  background: white;
}

.batch-card-row div p {
  margin-bottom: 4px;
  font-size: 16px;
  color: #6B6C6C;
}

.batch-card-row div span {
  color: #78b843;
  font-size: 14px;
  font-weight: 600;
}

.warning {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50vh;
}

.warning .text {
  background: #78b843;
  border-radius: 10px;
  color: #fff;
  padding: 20px;
  font-size: 30px;
}

.warning .text h1 {
  display: flex;
  justify-content: center;
}

.warning .text p {
  display: flex;
  justify-content: center;
  margin: 0;
}

.button-cadastrar{
  display: flex;
  align-items: flex-end;
  margin-bottom:12px ;
}

.button-cadastrar button{
  background-color: #78b843;
  color: #fff;
  border: none;
  border-radius:8px ;
  min-height: 38px;
  min-width: 265px;
}

@media screen and (max-width: 1199px) {
  .batch-card-row div {
    height: 90px;
    width: 15%;
    min-width: 140px;
  }

  .batch-card-row div p {
    font-size: 15px;
  }

  .batch-card-row div span {
    font-size: 13px;
  }

  .batch-info-container {
    padding-top: 32px;
  }

  .batch-info-container-ended-batch {
    padding-top: 32px;
  }
}

@media screen and (max-width: 991px) {
  .batch-date-modal {
    flex-direction: column;
  }

  .batch-modal-buttons-container {
    flex-direction: row;
    padding: 0;
    width: 100%;
  }

  .date-input {
    flex-direction: row;
    padding: 0;
    width: 100%;
  }

  .batch-card-row {
    flex-wrap: wrap;
  }

  .batch-card-row div {
    width: 22%;
    min-width: 180px;
  }
}


@media screen and (max-width: 768px) {
  .main-container {
    flex-direction: column;
  }

  .batch-info-container {
    padding: 0px;
  }

  .batch-info-container-ended-batch {
    padding: 0px;
    flex-direction: column;
  }

  .sensor-list-container {
    justify-content: center;
  }

  .batch-modal-buttons-container {
    flex-direction: row;
  }

  .batch-modal-button-end-batch {
    width: 50%;
    padding: 0 0 0 5px;
  }

  .batch-modal-button-edit-batch {
    width: 50%;
    padding: 0 5px 0 0;
  }

  .batch-card-row div {
    width: 30%;
    min-width: 150px;
  }

  .date-input {
    flex-direction: row;
  }

  .batch-information-cards {
    width: 100%;
  }

  .warning {
    height: 250px;
  }

  .warning h1 {
    font-size: 30px;
  }

  .warning p {
    font-size: 20px;
  }
}

@media screen and (max-width: 551px) {
  .batch-card-row div {
    width: 45%;
    min-width: 140px;
  }
}

@media screen and (max-width: 480px) {
  .batch-card-row div {
    width: 45%;
    min-width: 120px;
  }

  .warning h1 {
    font-size: 25px;
  }

  .warning p {
    font-size: 15px;
  }

  .batch-modal-buttons-container {
    flex-direction: column;
  }

  .batch-modal-button-end-batch {
    width: 100%;
    padding: 0;
  }

  .batch-modal-button-edit-batch {
    width: 100%;
    padding: 0;
  }

  .date-input {
    flex-direction: column;
  }

  .edit-losses-btn {
    width: 100%;
    margin-top: 0px;
    margin-bottom: 0px;
  }
}

@media screen and (max-width: 360px) {
  .batch-card-row div {
    width: 46%;
    min-width: 110px;
  }

  .warning {
    height: 200px;
  }

  .warning h1 {
    font-size: 20px;
  }

  .warning p {
    font-size: 10px;
  }
}

@media screen and (min-width: 800px) {
  .edit-losses-btn {
    margin-right: 16px;
    margin-top: 24px;
  }
}

.edit-losses-btn {
  background-color: #78b843;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 8px 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;


  transition: background-color 0.3s;
  min-width: 200px;
  display: flex;
  justify-content: center;
}

.edit-losses-btn:hover {
  background-color: #669c37;
}

.edit-losses-btn i {
  font-size: 14px;
}

.detalhar-lote {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}
</style>
